import { render } from "./Index.vue?vue&type=template&id=48cd2f5e"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Dashboard/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48cd2f5e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48cd2f5e', __exports__)) {
    console.log('reload')
    api.reload('48cd2f5e', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=48cd2f5e", () => {
    console.log('re-render')
    api.rerender('48cd2f5e', render)
  })

}


export default __exports__